import TableContainer from "@mui/material/TableContainer";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import TableBody from "@mui/material/TableBody";
import {Box, TableSortLabel} from "@mui/material";
import CmCreationStatusIconBox from "../../../components/CmCreationStatusIconBox/CmCreationStatusIconBox";
import React from "react";
import {CreationsTableProps} from "./types";
import './CreationsTable.scss'
import {CreationState} from "../../creations/types";
import Link from "@mui/material/Link";
import {useNavigate} from "react-router-dom";
import {visuallyHidden} from "@mui/utils";
import {Order} from "../../../config/general";

const CreationsTable: React.FC<CreationsTableProps> = ({creationsQueryResult, buttonGroup, onClickSort}) => {

    const navigate = useNavigate();

    const [orderBy, setOrderBy] = React.useState<string>('name');
    const [order, setOrder] = React.useState<Order>('asc');

    const handleRequestSort = (
        event: React.MouseEvent<unknown>,
        property: string,
    ) => {
        const isAsc = orderBy === property && order === 'asc';
        setOrder(isAsc ? 'desc' : 'asc');
        setOrderBy(property);
        onClickSort(property, isAsc ? 'desc' : 'asc')
    };

    const createSortHandler =
        (property: string) => (event: React.MouseEvent<unknown>) => {
            handleRequestSort(event, property);
        };

    const getCreationColorState = (creationState: CreationState, startAt: string, endAt: string) => {

        if (creationState === 'draft') {
            return 'draft'
        }

        if (creationState === 'accepted' && new Date(startAt) < new Date() && new Date(endAt) >= new Date()) {
            return 'published'
        }

        if (creationState === 'accepted' && new Date(startAt) > new Date()) {
            return 'planned'
        }

        if (creationState === 'accepted' && new Date() > new Date(endAt)) {
            return 'archived'
        }

        return null
    }


    return <>
        <TableContainer component={Paper}>
            <Table sx={{minWidth: 650}} aria-label="simple table">
                <TableHead>
                    <TableRow>
                        <TableCell>
                            <TableSortLabel
                                active={orderBy === 'name'}
                                direction={orderBy === 'name' ? order : 'asc'}
                                onClick={createSortHandler('name')}
                            >
                                Nazwa kreacji
                                {orderBy === 'name' ? (
                                    <Box component="span" sx={visuallyHidden}>
                                        {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                                    </Box>
                                ) : null}
                            </TableSortLabel>
                        </TableCell>
                        <TableCell align="right">Status</TableCell>
                        <TableCell align="right">Schemat</TableCell>
                        <TableCell align="right">Tagi</TableCell>
                        <TableCell align="right">
                            <TableSortLabel
                                active={orderBy === 'start_at'}
                                direction={orderBy === 'start_at' ? order : 'asc'}
                                onClick={createSortHandler('start_at')}
                            >
                                Data rozpoczecia
                                {orderBy === 'start_at' ? (
                                    <Box component="span" sx={visuallyHidden}>
                                        {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                                    </Box>
                                ) : null}
                            </TableSortLabel>
                        </TableCell>
                        <TableCell align="right">
                            <TableSortLabel
                                active={orderBy === 'end_at'}
                                direction={orderBy === 'end_at' ? order : 'asc'}
                                onClick={createSortHandler('end_at')}
                            >
                                Data zakończenia
                                {orderBy === 'end_at' ? (
                                    <Box component="span" sx={visuallyHidden}>
                                        {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                                    </Box>
                                ) : null}
                            </TableSortLabel>
                        </TableCell>
                        <TableCell align="right"></TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {creationsQueryResult.data.map((row) => (
                        <TableRow
                            className={`CreationStatus--${getCreationColorState(row.state, row.startAt, row.endAt)}`}
                            key={row.id}
                            sx={{'&:last-child td, &:last-child th': {border: 0}}}
                        >
                            <TableCell component="th" scope="row">
                                {row.name}
                            </TableCell>
                            <TableCell align="right">
                                <Box sx={{display: 'flex', justifyContent: 'end', alignItems: 'center'}}>
                                    <CmCreationStatusIconBox rejectionReason={row.rejectionReason}
                                                             state={row.state}></CmCreationStatusIconBox>
                                </Box>
                            </TableCell>
                            <TableCell component="th" scope="row" align="right">
                                <Link
                                    component="button"
                                    onClick={() => {
                                        navigate(`/drafts/${row?.draftId}`)
                                    }}
                                >
                                    <b>{row?.draftName}</b>
                                </Link>
                            </TableCell>
                            <TableCell align="right">{row.tagList.join(', ')}</TableCell>
                            <TableCell align="right">
                                {row.startAt && (new Date(row.startAt).toLocaleDateString())}
                            </TableCell>
                            <TableCell align="right">
                                {row.endAt && (new Date(row.endAt).toLocaleDateString())}
                            </TableCell>
                            <TableCell align="right">
                                {buttonGroup(row.id, row?.draftId)}
                            </TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>

    </>
};

export default CreationsTable;
